import script from "./ResultsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultsTable.vue?vue&type=script&setup=true&lang=js"

import "./ResultsTable.vue?vue&type=style&index=0&id=6fdaaad8&lang=css"

const __exports__ = script;

export default __exports__